import { AxiosResponse } from "axios";
import { httpRequest } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { Deal, DealsResponse, DealFiltersProps } from "@/types";

// Função para buscar deals
async function fetchDeals(
  filters?: DealFiltersProps
): Promise<DealsResponse> {
  const params = new URLSearchParams();

  if (filters?.page) params.append('page', filters.page);
  if (filters?.per_page) params.append('per_page', filters.per_page.toString());
  if (filters?.search) params.append('search', filters.search);
  if (filters?.lead_id) params.append('lead_id', filters.lead_id);
  if (filters?.stage_id) params.append('stage_id', filters.stage_id);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.assigned_to) params.append('assigned_to', filters.assigned_to);
  if (filters?.start_date) params.append('start_date', filters.start_date);
  if (filters?.end_date) params.append('end_date', filters.end_date);

  const deals = await httpRequest.get<DealsResponse>(
    `/clinic/crm/deals${params.toString() ? `?${params.toString()}` : ''}`
  );
  return deals.data;
}

// Hook para buscar deals paginados
export function useFetchDealsQuery(filters?: DealFiltersProps) {
  const dealsQuery = useQuery({
    queryKey: ["deals", filters],
    queryFn: () => fetchDeals(filters),
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });

  return {
    ...dealsQuery,
    data: dealsQuery?.data,
  };
}

// Função para buscar deal por ID
async function fetchDealById(id: string): Promise<AxiosResponse<Deal>> {
  return await httpRequest.get<Deal>(`/clinic/crm/deals/${id}`);
}

export function useFetchDealByIdQuery(id: string) {
  const dealQuery = useQuery({
    queryKey: ["deals", id],
    queryFn: () => fetchDealById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });

  return {
    ...dealQuery,
    data: dealQuery?.data?.data,
  };
}